export enum Environment {
  Jenkins = 'ci',
  Production = 'prod',
  Stage = 'stg',
  Development = 'dev',
}
